import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './../sideBar/sidebar';
import TopBar from '../topBar/topBar';
import './dashboardLayout.css';

const SIDEBAR_COLLAPSED_KEY = 'sidebar_collapsed';

const DashboardLayout = () => {
  // Persisted so the choice (e.g. "hide it while I'm in OTA Service") sticks
  // across page loads/tabs, not just for the current session.
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    () => localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true'
  );

  useEffect(() => {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  const toggleSidebar = () => setIsSidebarCollapsed((prev) => !prev);

  useEffect(() => {
    const collapse = () => setIsSidebarCollapsed(true);
    window.addEventListener('mavis-a11y-collapse-sidebar', collapse);
    return () => window.removeEventListener('mavis-a11y-collapse-sidebar', collapse);
  }, []);

  return (
    <div className={`dashboard-layout ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <Sidebar isCollapsed={isSidebarCollapsed} />

      <div className="dashboard-main-content">
        <TopBar isSidebarCollapsed={isSidebarCollapsed} onToggleSidebar={toggleSidebar} />

        <main id="main-content" className="content-wrapper" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
